import { useEffect, useState } from "react";
import { Button, Form, Offcanvas } from "react-bootstrap";
import { groupServices } from "../../APIServices/PasswordManagement/groupServices";
import Swal from "sweetalert2";

const UpdateGroup = ({
  Show,
  Hide,
  Title,
  setUpdator,
  groupId,
  isDark,
  groupData,
  auth
}) => {
  const [groupName, setGroupName] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedGroup = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to update this Group?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        setLoader(true)
        userData.groupId = groupId
        userData.groupName = groupName
        let data = await groupServices.updatedGroup(auth, userData)
        if (data?.statusCode === 200) {
          setUpdator(`groupList_${Math.floor(10000 + Math.random() * 90000)}`);
          Hide()
        }
        setLoader(false)
      }
    });
  };

  useEffect(() => {
    setGroupName(groupData?.groupName || "")
  }, [groupData]);
  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className={`${isDark ? "bg-dark" : "bg-light"} p-3 border-bottom`}>
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Group Name{" "}
            <abbr className="text-danger" title="Require">
              *
            </abbr>
          </Form.Label>
          <Form.Control
            type="text"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            className="interactive-input rounded-1"
            style={{ fontSize: 12, padding: "6px 15px" }}
            placeholder="Enter Group Name"
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className={`${isDark ? "bg-dark" : "bg-light"} p-2 border-top text-end`}>
        <Button
          onClick={updatedGroup}
          variant="outline-primary"
          disabled={!groupName || loader}
          style={{ fontSize: 13 }}
          className="rounded-1 py-1 px-3"
          title={Title}
        >
          {Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default UpdateGroup;
